<template>
  <div id="custom-login">
    <div id="overlay" class="normal off">
      <div class="clock-container backout">
        <div class="clock"></div>
      </div>
    </div>
    <div id="proposal-label" class="slowest blur">
		<span>Crm Ege Online Muhasebe hizmetinden en iyi performansı almak için Google Chrome ya da Firefox tarayıcılarından
			birini kullanmanızı tavsiye ederiz. Aşağıdaki linklerden istediğinize tıklayarak tarayıcınızı ücretsiz olarak
			indirebilirsiniz.</span>
      <div></div>
    </div>
    <div id="restriction-label" class="blur">
      <div class="rl-insider">
        <div class="rl-content">
				<span>Tarayıcınızın sürümü bu yazılımın kullandığı teknolojileri desteklememektedir. Aşağıdaki linklere
					tıklayarak dilediğiniz güncel tarayıcıyı bilgisayarınıza kurabilirsiniz. Gelinlikpro, en iyi deneyim için <b>Google
						Chrome</b> ya da <b>Firefox</b> tarayıcılarını önermektedir.</span>
          <ul>
            <li><a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank"><img
              src="https://kusaksoft.com/assets/images/bw_chrome.svg" title="Chrome Tarayıcı İndirin" /></a></li>
            <li><a href="https://www.mozilla.org/tr/firefox/new/" target="_blank"><img src="./images/bw_firefox.svg"
                                                                                       title="Firefox Tarayıcı İndirin" /></a></li>
            <li><a href="https://www.opera.com/tr/download" target="_blank"><img src="./images/bw_opera.svg"
                                                                                 title="Opera Tarayıcı İndirin" /></a></li>
            <li><a href="https://browser.yandex.com.tr/desktop/main/" target="_blank"><img
              src="assets/images/bw_yandex.svg" title="Yandex Tarayıcı İndirin" /></a></li>
            <li><a href="https://www.microsoft.com/tr-tr/windows/microsoft-edge" target="_blank"><img
              src="assets/images/bw_edge.svg" title="Microsoft Edge Tarayıcı İndirin" /></a></li>
          </ul>
        </div>
      </div>
    </div>
    <div id="cookie-label" class="slowest blur">
		<span><b>"Oturumum açık kalsın"</b> seçeneğini seçerek, sizi bir dahaki gelişinizde tanıyabilmemiz için
			bilgisayarınıza <b>"Cookie/Çerez"</b> adı verilen tanımlayıcı dosyaları yazmamıza izin vermiş olursunuz.</span>
    </div>
    <div id="panel-modal" class="normal blur b">
      <span class="heading">Sistem İletisi</span>
      <div class="modal-content"></div>
      <div id="close-modal" class="close-modal normal b" run="true" e="click" f="closeModal" touch="true">TAMAM</div>
    </div>
    <div class="password-reminder-container blur normal">
      <div class="pr-container-inside slow">
        <div class="reminder-wrapper"></div>
      </div>
    </div>
    <div class="content-wrapper slow">
      <div class="content">
        <div class="login-wrapper">
          <div class="profile-image"><img src="./images/fingerprint.svg" class="slow" /></div>
          <form id="frmLogin" @submit.prevent="submit">
            <input v-model="user.email" type="text" autocorrect="off" autocapitalize="none" id="login-username" name="login-username"
                   placeholder="Kullanıcı Adı" run="true" e="keyup" f="getLoginKey(this)" />
            <input v-model="user.password" type="password" autocorrect="off" autocapitalize="none" id="login-password" name="login-password"
                   placeholder="Şifre" run="true" e="keyup" f="getLoginKey(this)" />
            <button type="submit" id="login-button" class="login-button normal b">
              <i v-if="loading" class="simple-icon-reload"></i> Giriş Yap
            </button>
          </form>
          <div class="bottom-desc">KUŞAK Soft Teknolojiler Ltd. Şti. Bilgi Teknolojileri Lisanslı olarak hizmet
            vermektedir. <br />
            <br />
            Gelinlikpro bir Kuşaksoft® markasıdırr. <a href="https://kusaksoft.com/"><br />
              <span class="renk">www.kusaksoft.com</span></a>
          </div>
          <div class="kusak-soft slow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'Login2',
    data(){
      return {
        loading: false,
        user: {
          email: '',
          password: '',
        }
      }
    },
    methods: {
      ...mapActions(['login']),
      submit(){
        this.loading = true;
        this.login(this.user).then(() => {
          this.loading = false;
          window.location.href = '/';
        }).catch(error => {
          this.error(error.response.data);
          this.loading = false;
        });
      }
    },
  }
</script>

<style scoped>
  body,
  td,
  th {
    font-family: Roboto, sans-serif;
  }

  #custom-login {
    background-image: url(./images/bg.jpg);
    width: 100vw;
    max-width: 100%;
    height: 100vh;
  }

  @import url("https://fonts.googleapis.com/css?family=Roboto:400,100,300,500,700,900&amp;subset=latin,latin-ext");
  @import url("https://fonts.googleapis.com/icon?family=Material+Icons");

  *, *:before, *:after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
  *.b{border-radius:3px;}
  html, body{margin:0;padding:0;width:100%;height:100%;font-family:'Roboto', sans-serif;}
  ul, a, li{margin:0;padding:0;text-decoration:none;}
  body{overflow:hidden;overflow-y:auto;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;background-attachment:fixed;background-color:black;margin:0;padding:0;}

  div#overlay{position:fixed;z-index:99990;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3);}
  div#overlay.off{visibility:hidden;opacity:0;filter:alpha(opacity=0);}

  div#panel-modal{position:fixed;z-index:99991;width:350px;height:150px;margin:-106px 0 0 -175px;background:white;display:Table;top:50%;left:50%;box-shadow:0 0 6px rgba(125, 125, 125, .3);padding:20px;}
  div#panel-modal span{display:block;background:none !important;color:black !important;width:100%;padding:0 0 10px 0 !important;margin:0 0 10px 0 !important;border-bottom:1px solid #e1e1e1;}
  div#panel-modal div.modal-content{width:100%;height:68px;padding:6% 0;font-size:15px;float:left;text-align:center;font-weight:400;}

  div#panel-modal.blur{transform:scaleX(.8) translate3d(0, 50px, 0);opacity:0;filter:alpha(opacity=0);visibility:hidden;}

  div.clock-container{position:fixed;z-index:99991;background:#ac034c;border-radius:50%;padding:20px;position:fixed;z-index:99991;top:50%;left:50%;transform:scale(0);-webkit-transform:scale(0);-moz-transform:scale(0);margin:-32px 0 0 -32px;box-shadow:0 0 0 10px rgba(172,3,76,.2)}
  div.clock-container.on{transform:scale(1);-webkit-transform:scale(1);-moz-transform:scale(1);}
  .clock{width:24px;height:24px;background-color:transparent;box-shadow:inset 0px 0px 0px 2px #fff;border-radius:50%;position:relative;}
  .clock:after,.clock:before{position:absolute;content:"";background-color:#fff;}
  .clock:after{width:10px;height:2px;top:11px;left:11px;
    -webkit-transform-origin: 1px 1px;
    -moz-transform-origin: 1px 1px;
    transform-origin: 1px 1px;
    -webkit-animation: minute 1s linear infinite;
    -moz-animation: minute 1s linear infinite;
    animation: minute 1s linear infinite;
  }

  .clock:before{width:8px;height:2px;top:11px;left:11px;
    -webkit-transform-origin: 1px 1px;
    -moz-transform-origin: 1px 1px;
    transform-origin: 1px 1px;
    -webkit-animation: hour 8s linear infinite;
    -moz-animation: hour 8s linear infinite;
    animation: hour 8s linear infinite;
  }

  div#sms-modal{position:fixed;z-index:99992;width:350px;height:150px;margin:-106px 0 0 -175px;background:white;display:Table;top:50%;left:50%;box-shadow:0 0 6px rgba(125, 125, 125, .3);padding:20px;}
  div#sms-modal.blur{transform:scaleX(.8) translate3d(0, 50px, 0);opacity:0;filter:alpha(opacity=0);visibility:hidden;}

  /*------------ SMS Modal ------------ */
  div.verify-prefix{float:left;background:#86ac29;color:#fff;font-weight:300;font-size:16px;padding:8px 20px;margin:10px 0 0 0;border-radius:2px 2px 0 2px;}
  #password-reminder-gsm,#sms-code{width:100%;text-align:center;background:none;border:none;border-bottom:1px solid #86ac29;font-size:16px;color:#000;font-weight:300;margin:25px 0 0 0;font-family:'Roboto', sans-serif;letter-spacing:.5px;border-radius:0 !important;}

  div#sms-modal #sms-code{width:calc(100% - 77px);float:right;margin:5px 0 20px 0;padding:9px;}
  div#sms-modal .smsbtn{float:left;margin:0 10px 0 0;}
  div#sms-modal span{display:block;}

  #verify_gsm{width:calc(100% - 77px);float:right;margin:25px 10px 20px 10px;padding:9px;}
  #verify_gsm{width:96%;text-align:center;background:none;border:none;border-bottom:1px solid #86ac29;font-size:16px;color:#000;font-weight:300;font-family:'Roboto', sans-serif;letter-spacing:.5px;border-radius:0 !important;}
  /*------------ SMS Modal ------------ */

  .btn{height:36px;text-decoration:none;float:left;color:white;margin:0 10px 0 0;background-color: #7cb342 !important;line-height:36px;outline:0;padding:0 2rem;text-transform: uppercase;border:none;border-radius:2px;text-align:center;letter-spacing:.5px;}

  #cancel-validation{background-color: #B71C1C !important;}

  div#cookie-control{display:Table;margin:20px auto;cursor:pointer;}
  div#cookie-control .cookie-icon{float:left;display:block;margin:1px 0 0 0;}
  div#cookie-control span{display:block;float:left;color:white;font-size:16px;font-weight:200;padding:0 0 0 4px;opacity:1;}

  @-webkit-keyframes minute{
    0%{-webkit-transform:rotate(0deg);}
    50%{-moz-transform:rotate(90deg);}
    100%{-webkit-transform:rotate(360deg);}
  }
  @-moz-keyframes minute{
    0%{-moz-transform:rotate(0deg);}
    50%{-moz-transform:rotate(90deg);}
    100%{-moz-transform:rotate(360deg);}
  }
  @keyframes minute{
    0%{transform:rotate(0deg);}
    50%{-moz-transform:rotate(90deg);}
    100%{transform:rotate(360deg);}
  }
  @-webkit-keyframes hour{
    0%{-webkit-transform:rotate(0deg);}
    100%{-webkit-transform:rotate(360deg);}
  }
  @-moz-keyframes hour{
    0%{-moz-transform:rotate(0deg);}
    100%{-moz-transform:rotate(360deg);}
  }
  @keyframes hour{
    0%{transform:rotate(0deg);}
    100%{transform:rotate(360deg);}
  }

  ::-webkit-input-placeholder{color:rgba(255,255,255,.8);font-size:16px;font-weight:100;letter-spacing:.5px;}
  ::-moz-placeholder{color:rgba(255,255,255,.8);font-size:16px;font-weight:100;letter-spacing:.5px;}
  :-ms-input-placeholder{color:rgba(255,255,255,.8);font-size:16px;font-weight:100;letter-spacing:.5px;}
  input:-moz-placeholder{color:rgba(255,255,255,.8);font-size:16px;font-weight:100;letter-spacing:.5px;}

  input{outline:none !important;}

  div.bottom-desc{font-size:10px;font-weight:400;color:rgba(255,255,255,.7);text-align:center;margin:25px 0 0 0;padding:25px 0 0 0;border-top:1px solid rgba(255,255,255,.2);letter-spacing:.5px;}

  div.kusak-soft{margin:25px auto 0 auto;width:41px;height:49px;background:url(./images/kusak-soft.png) left;opacity:.5;filter:alpha(opacity=50);}
  div.kusak-soft:hover{width:150px;opacity:1;filter:alpha(opacity=100);}

  div.content-wrapper{display:table;width:100%;height:100%;}
  div.content-wrapper div.content{display:Table-cell;width:100%;height:100%;vertical-align:middle;}

  div.content-wrapper div.content div.login-wrapper{width:350px;padding:20px;margin:0 auto;}
  div.content-wrapper div.content div.login-wrapper input[type=text],div.content-wrapper div.content div.login-wrapper input[type=password]{width:100%;text-align:center;padding:10px;background:none;border:none;border-bottom:1px solid rgba(255,255,255,.3);font-size:20px;color:white;text-shadow:1px 1px 1px rgba(0,0,0,.6);font-weight:100;margin:25px 0 0 0;font-family:'Roboto', sans-serif;letter-spacing:.5px;border-radius:0 !important;}
  div.content-wrapper div.content div.login-wrapper input[type=text]:focus,div.content-wrapper div.content div.login-wrapper input[type=password]:focus{border-bottom:1px solid rgba(255,255,255,.6);}

  #password-reminder-gsm,#password-reminder-code{width:100%;text-align:center;padding:10px;background:none;border:none;border-bottom:1px solid #86ac29;font-size:20px;color:white;font-weight:100;margin:25px 0 0 0;font-family:'Roboto', sans-serif;letter-spacing:.5px;border-radius:0 !important;}

  #password-reminder-code{width:calc(100% - 80px);float:right;margin:0;}

  div.password-reminder-container ::-webkit-input-placeholder{color:rgba(255,255,255,.6);font-size:16px;font-weight:700;letter-spacing:.5px;}
  div.password-reminder-container ::-moz-placeholder{color:rgba(255,255,255,.6);font-size:16px;font-weight:700;letter-spacing:.5px;}
  div.password-reminder-container :-ms-input-placeholder{color:rgba(255,255,255,.6);font-size:16px;font-weight:700;letter-spacing:.5px;}
  div.password-reminder-container input:-moz-placeholder{color:rgba(255,255,255,.6);font-size:16px;font-weight:700;letter-spacing:.5px;}


  div.profile-image{display:table;background:rgba(255,255,255,.3);padding:15px;border-radius:50%;margin:0 auto;}
  div.profile-image img{width:125px;height:auto;display:block;margin:auto;border-radius:50%;}
  div.profile-image.full{padding:0;}
  div.profile-image.full img{width:155px;height:auto;box-shadow:0 0 6px rgba(0,0,0,.3);}

  .login-button{border:0;display:table;padding:8px 16px;background:#86ac29;color:white;font-size:16px;margin:25px auto;font-weight:100;cursor:pointer;}
  .login-button:hover{background:white;color:#86ac29;}

  div.reminder-send,div.reminder-cancel{display:table;padding:8px 16px;background:#86ac29;color:#fff;font-size:16px;margin:25px 0 0 10px;font-weight:100;cursor:pointer;}
  div.reminder-send:hover,div.reminder-cancel:hover{background:#5f7a1d;color:#fff;}

  div.reminder-button{float:right;}

  div.close-modal{padding:8px 16px;background:#86ac29;color:white;font-size:16px;margin:25px 0 0 0;float:left;font-weight:100;cursor:pointer;}
  div.close-modal:hover{background:white;color:#86ac29;}

  div.password-reminder-container{display:table;position:fixed;z-index:900;width:300%;height:100%;}
  div.password-reminder-container div.pr-container-inside{display:table-cell;width:100%;height:100%;vertical-align:middle;}
  div.password-reminder-container.blur{visibility:hidden;opacity:0;filter:alpha(opacity=0);transform:translate3d(0, 50px, 0);}

  div.password-reminder-container span{display:block;width:100%;margin:0 0 25px 0;color:#fff;font-weight:600;text-align:center;font-size:12px;}
  span.heading{font-size:24px !important;font-weight:100 !important;}

  div.reminder-wrapper{padding:20px;width:33.333333%;float:left;}
  div.reminder-wrapper div.cc{width:350px;margin:0 auto;}

  div.g-recaptcha{display:table;width:auto;margin:25px auto 0 auto;}

  div.open-remider{background:url(https://kusaksoft.com/assets/images/reminder.svg) 0 13px no-repeat;color:white;font-size:16px;font-weight:100;padding:12px 0px 12px 25px;display:table;margin:0 auto;cursor:pointer;}

  div#reminder-cancel-last{float:none;margin:25px auto 0 auto !important;}

  div.verify-prefix{float:left;background:#86ac29;color:#fff;font-weight:600;font-size:18px;padding:6px 18px;margin:10px 0 0 0;border-radius:20px 20px 0 20px;}

  input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active{transition: background-color 1000s ease-in-out 0s;-webkit-text-fill-color:white !important;}

  div#restriction-label{position:fixed;z-index:99999;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.85);}
  div#restriction-label.blur{visibility:hidden;}
  div#restriction-label div.rl-insider{display:table;width:100%;height:100%;}
  div#restriction-label div.rl-insider div.rl-content{display:table-cell;vertical-align:middle;width:100%;max-width:650px;color:White;text-align:center;}

  div#proposal-label{position:fixed;z-index:99998;top:0;left:0;right:0;padding:10px 40px;background:rgba(145,171,58,.9);color:White;font-size:13px;font-weight:200;}
  div#proposal-label span{display:block;margin:0 auto 10px auto;line-height:19px;text-align:center;}
  div#proposal-label div{margin:0 auto;width:60px;}
  div#proposal-label a{display:block;float:left;width:24px;height:24px;margin:0 10px 0 0;}
  div#proposal-label a:last-child{margin:0;}
  div#proposal-label a img{width:24px;height:24px;border:none;}

  div#cookie-label{position:fixed;z-index:99997;top:0;left:0;right:0;padding:10px 40px;background:rgba(145,171,58,.9);color:White;font-size:13px;font-weight:14px;}
  div#cookie-label span{display:block;margin:0 auto;line-height:19px;text-align:center;}
  div#cookie-label div{margin:0 auto;width:60px;}
  div#cookie-label a{display:block;float:left;width:24px;height:24px;margin:0 10px 0 0;}
  div#cookie-label a:last-child{margin:0;}
  div#cookie-label a img{width:24px;height:24px;border:none;}

  div#proposal-label.blur,div#cookie-label.blur{transform:translate3d(0, -100%, 0);-moz-transform:translate3d(0, -100%, 0);-webkit-transform:translate3d(0, -100%, 0);-ms-transform:translate3d(0, -100%, 0);}

  img.close-proposal{position:absolute;right:20px;top:23px;width:16px;height:16px;}
  div#cookie-label img.close-proposal{top:15px !important;}

  div#restriction-label div.rl-insider div.rl-content span{display:block;width:100%;max-width:700px;font-size:16px;line-height:28px;margin:0 auto;}
  div#restriction-label div.rl-insider div.rl-content ul{width:100%;max-width:700px;margin:40px auto 0 auto;padding:0;list-style:none;}
  div#restriction-label div.rl-insider div.rl-content ul li{width:20%;float:left;}
  div#restriction-label div.rl-insider div.rl-content ul li a{display:block;width:100%;}
  div#restriction-label div.rl-insider div.rl-content ul li a img{display:block;margin:auto;width:40%;height:auto;border:0;}

  @media only screen and (max-width:660px) and (min-width:50px){
    div#proposal-label{display:none;}
    div.profile-image img{width:60px;height:60px;}
    div.profile-image.full img{padding:0;width:90px !important;height:90px !important;}
    div.content-wrapper div.content div.login-wrapper{padding:20px 0;width:calc(100% - 80px);}
    div#panel-modal{width:300px;margin:-106px 0 0 -150px;}
    div.password-reminder-container div.reminder-wrapper  div.cc{padding:0 0;width:calc(100% - 40px);}

    div.g-recaptcha{transform:scale(0.9);transform-origin:0 0;-moz-transform-origin:0 0;margin:25px auto 0 auto;}
  }

  /*------------------------------Transitions-----------------------------*/
  .slowest{-webkit-transition: all 2000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 2000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 2000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 2000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .slower{-webkit-transition: all 1000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 1000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 1000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 1000ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .slow{-webkit-transition: all 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .normal{-webkit-transition: all 600ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 600ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 600ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 600ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .fast{-webkit-transition: all 400ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 400ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 400ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 400ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .faster{-webkit-transition: all 200ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 200ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 200ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 200ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .fastest{-webkit-transition: all 100ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition: all 100ms cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition: all 100ms cubic-bezier(0.230, 1.000, 0.320, 1.000); transition: all 100ms cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); -o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000); /* easeOutQuint */}
  .spin{-webkit-transform: rotate(180deg);-moz-transform: rotate(180deg);-o-transform: rotate(180deg);-ms-transform: rotate(180deg);transform: rotate(180deg);}
  .spin2{-webkit-transform: rotate(225deg);-moz-transform: rotate(225deg);-o-transform: rotate(225deg);-ms-transform: rotate(225deg);transform: rotate(225deg);}
  .backout{-webkit-transition: all 1000ms cubic-bezier(0.125, 0.940, 0.000, 1); /* older webkit */-webkit-transition: all 1000ms cubic-bezier(0.125, 0.940, 0.000, 1.395); -moz-transition: all 1000ms cubic-bezier(0.125, 0.940, 0.000, 1.395); -o-transition: all 1000ms cubic-bezier(0.125, 0.940, 0.000, 1.395); transition: all 1000ms cubic-bezier(0.125, 0.940, 0.000, 1.395);-webkit-transition-timing-function: cubic-bezier(0.125, 0.940, 0.000, 1);-webkit-transition-timing-function: cubic-bezier(0.125, 0.940, 0.000, 1.395); -moz-transition-timing-function: cubic-bezier(0.125, 0.940, 0.000, 1.395); -o-transition-timing-function: cubic-bezier(0.125, 0.940, 0.000, 1.395); transition-timing-function: cubic-bezier(0.125, 0.940, 0.000, 1.395);
  }
  /*------------------------------Transitions-----------------------------*/
</style>
